import { apiService } from './apiService';
import { API_PATHS } from '../utils/apiPaths';
import type {
  AuthResponse,
  ForgotPasswordInitiateRequest,
  ForgotPasswordInitiateResponse,
  ForgotPasswordVerifyOtpRequest,
  ForgotPasswordVerifyOtpResponse,
  LoginRequest,
  RefreshTokenRequest,
  RegisterRequest,
  ResetPasswordRequest,
} from '../components/auth/models/types';

export class AuthService {
  private readonly AUTH_BASE = '/auth';

  async login(credentials: LoginRequest): Promise<AuthResponse> {
    return apiService.post<AuthResponse>(`${this.AUTH_BASE}/login`, credentials);
  }

  async register(data: RegisterRequest): Promise<AuthResponse> {
    return apiService.post<AuthResponse>(`${this.AUTH_BASE}/register`, data);
  }

  async refreshToken(refreshToken: string): Promise<AuthResponse> {
    const request: RefreshTokenRequest = { refreshToken };
    return apiService.post<AuthResponse>(`${this.AUTH_BASE}/refresh`, request);
  }

  async logout(): Promise<void> {
    await apiService.post(API_PATHS.ADMIN_LOGOUT, {});
  }

  async initiateForgotPassword(email: string): Promise<ForgotPasswordInitiateResponse> {
    const request: ForgotPasswordInitiateRequest = { email };
    return apiService.post<ForgotPasswordInitiateResponse>(
      API_PATHS.FORGOT_PASSWORD_INITIATE,
      request
    );
  }

  async verifyForgotPasswordOtp(
    payload: ForgotPasswordVerifyOtpRequest
  ): Promise<ForgotPasswordVerifyOtpResponse> {
    return apiService.post<ForgotPasswordVerifyOtpResponse>(
      API_PATHS.FORGOT_PASSWORD_VERIFY_OTP,
      payload
    );
  }

  async resetPassword(payload: ResetPasswordRequest): Promise<{ message?: string }> {
    return apiService.post<{ message?: string }>(API_PATHS.RESET_PASSWORD, payload);
  }
}

export const authService = new AuthService();
